<template>
    <loading name="load page detail">
        <div class="container body fix-footer">
            <div class="row justify-content-center">
                <div class="col-md-8 mt-5 mb-3">
                    <div class="card">
                        <div class="card-header">
                            <h3>{{$t('pages.EditPage')}}</h3>
                        </div>
                        <div class="card-body">
                            <div class="alert alert-danger" v-if="error">
                                {{$t(error)}}
                            </div>
                            <form @submit="submit">
                                <formly-form :form="form" :model="model" :fields="fields" ref="createPage"/>
                                <div class="text-right">
                                    <button type="submit" class="btn btn-secondary" @click="deletePage">{{ $t('button.Delete') }}</button>
                                    <button type="submit" class="btn btn-primary ml-3">{{ $t('button.Save') }}</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </loading>
</template>

<script>
  import isInt from 'validator/lib/isInt';
  import isLength from 'validator/lib/isLength';
  import { mapActions } from 'vuex';
  import { ERROR_MESSAGES, ROUTER_NAMES } from '../../constants';

  export default {
    name: 'EditPage',
    created() {
      this.$wait.start('load page detail');
      this.loadPageDetail({
        slug: this.slug
      })
        .then(() => {
          this.model = Object.assign({}, this.page);
          this.$wait.end('load page detail');
        })
        .catch((e) => {
          const response = e.response ? e.response : {};
          if (response.status == 404) {
            this.$router.push({
              name: ROUTER_NAMES.NOT_FOUND,
              params: {
                0: ROUTER_NAMES.NOT_FOUND
              }
            });
          } else {
            this.$router.push({
              name: ROUTER_NAMES.ERROR
            });
          }
        });
    },
    data() {
      return {
        error: '',
        form: {},
        model: {
          title: '',
          body: '',
          short: '',
          status: 'published',
        },
        fields: [
          {
            key: 'title',
            type: 'input',
            templateOptions: {
              label: this.$t('fields.Title')
            },
            required: true,
            validators: {
              validTitle: {
                expression(field, model, next) {
                  next(isLength(model[field.key], { min: 3 }));
                },
                message: 'Nazov musi obsahovat aspoň 3 znaky'
              }
            }
          },
          {
            key: 'body',
            type: 'mce',
            templateOptions: {
              label: this.$t('fields.Content'),
            },
            required: true,
            validators: {
              validShort: {
                expression(field, model, next) {
                  next(isLength(model[field.key], {
                    min: 10
                  }));
                },
                message: this.$tc('validation.min', 10)
              }
            }
          },
          {
            key: 'order',
            type: 'input',
            templateOptions: {
              label: this.$t('fields.Order'),
              inputType: 'number'
            },
            validators: {
              validShort: {
                expression(field, model, next) {
                  next(isInt(model[field.key].toString()));
                },
                message: this.$tc('validation.int', 10)
              },
            },
            required: true,
          }
        ]
      };
    },
    computed: {
      page() {
        return this.state().pages.details[this.slug];
      },
      slug() {
        return this.$route.params.slug;
      }
    },
    methods: {
      ...mapActions(['editPage', 'loadPage', 'loadPageDetail']),
      deletePage(e) {
        e.preventDefault();
        if (!this.form.$valid) return;

        this.editPage({
          ...this.model,
          active: false
        }).then((response) => {
            this.$router.push({
              name: ROUTER_NAMES.PAGE,
              params: {
                slug: this.slug
              }
            });
          })
          .catch((err) => {
            this.error = ERROR_MESSAGES.INTERNAL_SERVER_ERROR;
          });
      },
      submit(e) {
        e.preventDefault();

        this.$refs.createPage.validate()
          .then(() => {
            if (!this.form.$valid) return;

            this.editPage({
              ...this.model
            })
              .then((response) => {
                this.$router.push({
                  name: 'page',
                  params: {
                    slug: this.slug
                  }
                });
              })
              .catch((err) => {
                this.error = ERROR_MESSAGES.INTERNAL_SERVER_ERROR;
              });
          });
      }
    }
  };
</script>

<style scoped>

</style>
